// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3v55C","description":"PatientConsentPreview_description__2b-g6"};